import { css } from "@emotion/react"

export const TRANSITION = css`
  transition: 0.1s ease-in-out;
`
